// Advertisement Module — advertisement-module.*
//
// Backend permission ids:
//   1497 — index, summary, show
//   1498 — status (pause / republish)
//   1499 — renew

/** advertisement-module.index / advertisement-module/summary */
export const ADVERTISEMENTS_INDEX = 1497;
/** advertisement-module.show — same backend permission as index */
export const ADVERTISEMENTS_SHOW = ADVERTISEMENTS_INDEX;
/** advertisement-module/{id}/status */
export const ADVERTISEMENTS_EDIT = 1521;
/** advertisement-module/{id}/renew */
export const ADVERTISEMENTS_RENEW = 1499;
